<mat-toolbar class="modal-title">
    <span>{{'units.device.set_config'|translate}}</span>
    <span class="trace-spacer"></span>
    <lib-button (click)="dialogRef.close()" icon="close" color="none" textColor="muted"
        tooltip="{{'viewer.close'|translate}}">
    </lib-button>
</mat-toolbar>

<div class="tracker-list">
    @if(trackers){
    <div class="chip-list">
        @for( tracker of trackers; track tracker.id ){
        <lib-chip color="muted" [text]="tracker.name"></lib-chip>
        }
    </div>
    }
</div>

<mat-form-field>
    <mat-label>{{'units.device.config_list'|translate}} </mat-label>

    <mat-select [(ngModel)]="configId">
        <mat-option *ngFor="let config of configs" [value]="config.id">{{config.name}} - {{config.type}}</mat-option>
    </mat-select>
</mat-form-field>

<mat-dialog-actions>
    <span class="trace-spacer"></span>
    <lib-button color="primary" icon="save" text="{{'form.save'|translate}}" (click)="setConfig()"></lib-button>
</mat-dialog-actions>